<template>
  <b-tab title="Groupes d'items">
    <div class="px-2" style="max-width: 100%; overflow-x: hidden;">
      
      <!-- Liste des groupes -->
      <div 
        v-for="(group, gIdx) in test.itemGroups" 
        :key="gIdx" 
        class="border rounded p-3 mb-3 shadow-sm bg-white"
      >
        <!-- En-tête groupe -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <b-form-input 
            v-model="group.groupName" 
            placeholder="Nom du groupe" 
          />
          <b-button 
            variant="danger" 
            size="sm" 
            @click="removeItemGroup(gIdx)"
          >
            Supprimer
          </b-button>
        </div>

        <!-- Sélection des items -->
        <b-form-group label="Sélection des items">
          <b-form-checkbox-group 
            v-model="group.selectedItemIds" 
            :options="itemsOptions" 
            stacked 
          />
        </b-form-group>
      </div>

      <!-- Bouton ajout -->
      <div class="d-flex justify-content-end mt-3">
        <b-button 
          size="sm" 
          variant="success" 
          @click="addEmptyGroup"
        >
          ➕ Ajouter un nouveau groupe
        </b-button>
      </div>

      <!-- Bouton enregistrer -->
      <div class="d-flex justify-content-end mt-3">
        <b-button 
          variant="primary" 
          size="lg" 
          @click="saveUpdatedTest"
        >
          Enregistrer
        </b-button>
      </div>
    </div>
  </b-tab>
</template>

<script>
export default {
  name: "TestGroups",
  props: {
    test: { type: Object, required: true }
  },
  data() {
    return {
      itemsOptions: []
    };
  },
  mounted() {
    if (!this.test.itemGroups) this.$set(this.test, 'itemGroups', []);
    if (!this.test.items) this.$set(this.test, 'items', []);
    this.buildItemsOptions();

    this.test.itemGroups.forEach(group => {
      if (!Array.isArray(group.selectedItemIds)) {
        group.selectedItemIds = group.items || [];
      }
    });
  },
  watch: {
    'test.items': {
      handler(newItems) {
        this.buildItemsOptions();
        this.test.itemGroups?.forEach(group => {
          group.selectedItemIds = (group.selectedItemIds || []).filter(id =>
            newItems.find(item => item._localId === id)
          );
        });
      },
      deep: true
    }
  },
  methods: {
    buildItemsOptions() {
      this.itemsOptions = (this.test.items || []).map(item => ({
        text: item.name || 'Item',
        value: item._localId
      }));
    },
    addEmptyGroup() {
      if (!this.test.itemGroups) this.$set(this.test, 'itemGroups', []);
      this.test.itemGroups.push({
        groupName: '',
        selectedItemIds: [],
        items: []   
      });
    },
    removeItemGroup(gIdx) {
      this.test.itemGroups.splice(gIdx, 1);
    },
    async saveUpdatedTest() {
      const testId = this.test._id || this.test.id;
      if (!testId) return;

      const testToSave = {
        ...this.test,
        itemGroups: this.test.itemGroups.map(g => ({
          groupName: g.groupName,
      selectedItemIds: g.selectedItemIds || []  
        }))
      };

      try {
        const res = await fetch(`/api/tests/${testId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(testToSave),
        });

        if (res.ok) {
          this.$bvToast?.toast('Modifications enregistrées avec succès', {
            title: 'Succès',
            variant: 'success',
            solid: true
          });
        } else {
          this.$bvToast?.toast('Erreur lors de l\'enregistrement', {
            title: 'Erreur',
            variant: 'danger',
            solid: true
          });
        }
      } catch (e) {
        this.$bvToast?.toast('Erreur réseau ou serveur lors de l\'enregistrement', {
          title: 'Erreur',
          variant: 'danger',
          solid: true
        });
      }
    }
  }
};
</script>
